<template>
  <ul :class="$style.container">
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="[[$style.item], { [$style.isSelected]: isSelected(index) }]"
      @click="onSelect(index)"
    >
      {{ item.option_menu }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'OptionMenu',

  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedOption: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    isSelected(index) {
      return this.selectedOption === index
    },
    onSelect(index) {
      if (index === this.selectedOption) return
      this.$emit('onSelect', index)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @include above(small) {
    flex-direction: row;
  }
}
.item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80vw;
  max-width: 327px;
  height: 110px;
  margin: 12px 0;
  border: 2px solid #eae9e3;
  border-radius: 8px;

  font-size: 20px;

  cursor: pointer;

  @include above(small) {
    width: 220px;
    height: 128px;
    margin: 12px;
  }
}
.isSelected {
  border-color: #2d50e6;

  box-shadow: 0 0 0 4px #d6e3fd;
}
</style>
